const tutorRoutes = [
    {
        path: "profile",
        name: "TPTutorProfile",
        component: () =>
            import ("../views/TutorPanel/profile/TutorProfile"),
        meta: {
            icon: "mdi-account-cash-outline",
            title: "Accounts",
            subtitle: "Welcome to QS Learning Students",
        }
    },
    {
        path: "classes",
        name: "TutorClasses",
        component: () =>
            import ("../views/TutorPanel/classes/Classes"),
        meta: {
            panelType: "Tutor",
            icon: "mdi-teach",
            title: "Classes",
            subtitle: "Welcome to QS Learning Classes",
        },
    },
    {
        path: "accounts",
        name: "TutorAccounts",
        component: () =>
            import ("../views/TutorPanel/accounts/Accounts.vue"),
        meta: {
            icon: "mdi-account-cash-outline",
            title: "Accounts",
            subtitle: "Welcome to QS Learning Students",
        },
    },
    {
        path: "students",
        name: "TutorStudents",
        component: () =>
            import ("../views/TutorPanel/students/Students.vue"),
        meta: {
            icon: "fas fa-user-graduate",
            title: "TutorStudents",
            subtitle: "Welcome to QS Learning Students",
        },
    },
    {
        path: "student/profile/:id",
        name: "StudentProfileTP",
        component: () =>
            import ("../views/TutorPanel/student-profile/index.vue"),
        meta: {
            icon: "",
            title: "Student Profile",
            subtitle: "Welcome to QS Learning Student",
        },
    },
    {
        path: "tutor/uploaded/work",
        name: "TutorUploadedWork",
        component: () =>
            import ("../views/TutorPanel/uploadedWork/index.vue"),
        meta: {
            icon: "",
            title: "Student Work",
            subtitle: "Welcome to QS Learning Student",
        },
    }, {
        path: "tutor/WorkSheet",
        name: "TutorWorkSheet",
        component: () =>
            import ("../views/TutorPanel/workSheet/index.vue"),
        meta: {
            icon: "",
            title: "Student Work",
            subtitle: "Welcome to QS Learning Student",
        },
    },

]

export default tutorRoutes